import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

const SystemAnnouncements = ({systemAnnouncementsToShow}) => {
  
  const [messages, setMessages] = useState([]);
  const dispatch = useDispatch();

  const showModal = () =>{
    document.body.classList.add("modal-open-7");
  }

  const hideModal = () =>{
    localStorage.setItem("announcementSeen","yes");
    document.body.classList.remove("modal-open-7");
  }

  useEffect(() => {

      if(systemAnnouncementsToShow?.length > 0){
        const messages = systemAnnouncementsToShow.map((e) =>
              e.message.replace(/\n/g, "")
            );
        setMessages(messages);
        showModal();
      }

  }, [systemAnnouncementsToShow]);




  return (
    <>

  <div id="modal-open-7" className="lightbox-panel centerPopup" aria-labelledby="systemannouncements" aria-modal="true" role="dialog">
    <div className="inner-lightbox-panel sm-lightbox-pannel pb-0">
      <div className="modal-header flex padd-lr">
        <h5 id="systemannouncements">Announcements</h5>
      </div>
      <div className="lightbox-content padd-22">
        <ul>
          {messages.map((message, index) => (
            <li key={index}>{message}</li>
          ))}
        </ul>
      </div>
      <div className="modal-footer modal-footer-border flex px-22">
        <button className="blue-btn tutorial-next active" onClick={hideModal}>Close</button>
      </div>
    </div>
  </div>


    </>
  );
};

export default SystemAnnouncements;
